<template>
  <v-breadcrumbs class="hidden-sm-and-down" :items="levelList" divider="/">
    <template v-slot:item="props">
      <!--      @click.prevent="handleLink(props.item)"-->
      <span>
        {{ generateTitle(props.item.meta.title) }}
      </span>
    </template>
  </v-breadcrumbs>
</template>

<script>
const pathToRegexp = require('path')

export default {
  name: 'AppBreadcrumbs',
  data: () => ({
    levelList: null
  }),
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    generateTitle(title) {
      const hasKey = `${title}`
      if (hasKey) {
        const translatedTitle = `${title}`
        return translatedTitle
      }
      return title
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name)

      const first = matched[0]
      if (first && first.name.trim().toLocaleLowerCase() !== 'dashboard') {
        matched = [{ path: '/dashboard', meta: { title: 'Главная страница' } }].concat(matched)
      }

      this.levelList = matched.filter((item) => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    pathCompile(path) {
      const { params } = this.$route
      const toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      console.groupCollapsed('handleLink')
      const { redirect, path } = item
      console.log(`redirect=${redirect}, path=${path}`)
      if (redirect) {
        console.log('redirect')
        this.$router.push(redirect)
        console.groupEnd()
        return
      }
      this.$router.push(this.pathCompile(path))
      console.groupEnd()
    }
  }
}
</script>
